import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MuiButton from '@material-ui/core/Button';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';

import { useTranslation } from 'utils/modifiedTranslation';
import useStyles from './styles';

/**
 * A button the has a next icon and a label
 */
const ArrowForwardButton = props => {
  const { t } = useTranslation();
  const { label, onClick, isDisabled } = props;
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const provider = providerSpecific?.code;
  const classes = useStyles({ provider });
  return (
    <MuiButton className={classes.root} onClick={onClick} color="primary" disabled={isDisabled}>
      {t(label)}
      <ArrowForwardIos
        fontSize={provider ? 'small' : 'medium'}
        color={isDisabled ? 'disabled' : provider ? '#0C9BED' : 'primary'} />
    </MuiButton>
  );
};

ArrowForwardButton.propTypes = {
  /**
   * Label of the button. If not passed then only icon will be displayed
   */
  label: PropTypes.string,
  /**
   * Function to call when button clicked
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Should disable the button
   */
  isDisabled: PropTypes.bool
};

export default ArrowForwardButton;
